import React from 'react';
import FieldError from '../Fragments/FieldError';
import moment from 'moment';

const MonthYearDate = React.createClass({
    propTypes: {
        earliestYear: React.PropTypes.number.isRequired,
        latestYear: React.PropTypes.number.isRequired,
    },

    getInitialState() {
        return {
            hasError: false,
            isValid: false,
            month : '',
            year : '',
        };
    },

    updateInputMonth : function(e) {
        this.setState({
            month : e.target.value
        });
    },

    updateInputYear : function(e) {
        this.setState({
            year : e.target.value
        });
    },

    render: function() {
        let years = [];
        for(let i = this.props.earliestYear; i <= this.props.latestYear; i++) years.push(i);

        return (
            <question-row>
                <div className="question-main date-selector">
                    <div className="question-top">
                        <label>Claim date</label>
                    </div>
                    <div className="question-input">
                        <div className="input-column">
                            <label htmlFor="claim-month" className="sr-only">Month</label>
                            <select
                                name="claim-month"
                                id="claim-month"
                                className="form-control"
                                placeholder="Month"
                                value={this.state.month}
                                onChange={this.updateInputMonth}
                            >
                                <option value="" />
                                {Array.apply(0, Array(12)).map(function (x, i) {
                                    let month = String(i + 1);
                                    return <option key={month} value={month}>{moment().month(i).format('MMM')}</option>;
                                })}
                            </select>
                        </div>
                        <div className="input-column">
                            <label htmlFor="claim-year" className="sr-only">Year</label>
                            <select
                                name="claim-year"
                                id="claim-year"
                                className="form-control"
                                placeholder="Year"
                                value={this.state.year}
                                onChange={this.updateInputYear}
                            >
                                <option value="" />
                                {years.map(function (x) {
                                    let year = String(x);
                                    return <option key={year} value={year}>{year}</option>;
                                })}
                            </select>
                        </div>
                    </div>
                    {this.state.hasError ? <FieldError errors={this.state.errors} /> : null}
                </div>
            </question-row>
        );
    }
});

export default MonthYearDate;



/** WEBPACK FOOTER **
 ** ./src/components/Fields/MonthYearDate.js
 **/